// @flow
const NOTIFICATIONS_ENDPOINT = '/services/notifications';
export const NOTIFICATION_PREFERENCES_ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/preferences`;
export const WATCHED_KEYWORDS_ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/watched-keywords`;


// WEBPACK FOOTER //
// ./src/app/modules/notificationPreferences/constants.js